import React, { useEffect, useMemo, useState } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { BreadCrumbs } from "components/_ProductConfigurator/Breadcrumb/BreadCrumbs";

import {
  useProductsOverviewActions,
  useProductsOverviewStore,
} from "stores/productsOverviewStore";
import { useProjectDataStore } from "stores/projectStore";
import { useAllProducts } from "hooks/productHooks/useAllProducts";
import { useTranslate } from "hooks";

const getFlat = (tree) =>
  tree.flatMap(({ nodes, ...item }) =>
    nodes ? [item, ...getFlat(nodes)] : item,
  );

const generateBreadcrumbs = (keyList, allItems) =>
  keyList.map((item) => allItems.find((product) => product?.key === item));

export const ProductBreadcrumb = Scrivito.connect(({ productName = null }) => {
  const [flattedProducts, setFlattedProducts] = useState([]);
  const translate = useTranslate();
  const projectId = useProjectDataStore((state) => state.projectId);

  const allProducts = useAllProducts();

  const selectedCategory = useProductsOverviewStore((state) => {
    const prodCategId = state.productCategoryId;
    if (!prodCategId) {
      return [];
    }
    return Array.isArray(prodCategId) ? prodCategId : [prodCategId];
  });

  const { setProductCategoryId, navigateToProductListPage } =
    useProductsOverviewActions();

  useEffect(() => {
    if (allProducts) {
      setFlattedProducts(getFlat(allProducts));
    }
  }, [allProducts]);

  useEffect(() => {
    if (flattedProducts?.length && selectedCategory?.length) {
      setProductCategoryId(selectedCategory);
    }
  }, [selectedCategory, flattedProducts, setProductCategoryId]);

  const breadcrumbsList = useMemo(() => {
    const { parentId } = Scrivito.currentPageParams();
    const breadcrumbsKeyList =
      (selectedCategory.length && selectedCategory) ||
      flattedProducts.find(
        (product) =>
          product.name === productName &&
          (!parentId || parentId === product.parentId),
      )?.keyList;

    const productListBreadcrumbItem = {
      title: translate("PRODUCTS_OVERVIEW_PRODUCTS_LIST_TITLE"),
      handleClick: () => {
        navigateToProductListPage({ projectId });
      },
    };

    if (flattedProducts?.length && breadcrumbsKeyList?.length) {
      return [
        productListBreadcrumbItem,
        ...generateBreadcrumbs(breadcrumbsKeyList, flattedProducts).map(
          (item) => ({
            ...item,
            title: item.name,
            handleClick: () => {
              setProductCategoryId(item.keyList);
              return item.serieId !== undefined
                ? undefined
                : navigateToProductListPage({
                    projectId,
                    shouldKeepProductCategories: true,
                  });
            },
          }),
        ),
      ];
    }
    if (breadcrumbsKeyList) {
      return [productListBreadcrumbItem];
    }
  }, [
    selectedCategory,
    flattedProducts,
    translate,
    productName,
    navigateToProductListPage,
    projectId,
    setProductCategoryId,
  ]);

  return (
    breadcrumbsList && (
      <BreadCrumbs
        classNames={cx("mb-3 font-md")}
        breadcrumbList={breadcrumbsList}
      />
    )
  );
});
